import AddIcon from "@mui/icons-material/Add"
import {Button, Menu, MenuItem, Typography} from "@mui/material"
import React, {useContext, useRef, useState} from "react"
import {ActionContext} from "../../../../context/ActionContextProvider"

const ListItemsManagerAdd = ({addressList}) => {
    const {triggerAction} = useContext(ActionContext)

    const [anchorEl, setAnchorEl] = useState(null)
    const containerRef = useRef(null)
    const open = Boolean(anchorEl)
    const onHover = event => {
        setAnchorEl(event.currentTarget)
    }

    const closeMenu = () => {
        setAnchorEl(null)
    }

    const addRisikoortForAddress = address => {
        triggerAction("CREATE_RISIKOORT", address)
        closeMenu()
    }

    return (
        <>
            <Button
                ref={containerRef}
                onMouseEnter={onHover}
                startIcon={<AddIcon />}
            >
                <Typography>Risikoort</Typography>
            </Button>
            <Menu
                id={`adresse-menu`}
                anchorEl={anchorEl}
                open={open}
                onClose={closeMenu}
                slotProps={{
                    paper: {onMouseLeave: closeMenu},
                }}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                {addressList.map(address => (
                    <MenuItem onClick={() => addRisikoortForAddress(address)}>
                        {address.postleitzahl ?? ""} {address.ort ?? ""} -{" "}
                        {address.strasse ?? ""} {address.hausnummer ?? ""}
                    </MenuItem>
                ))}
            </Menu>
        </>
    )
}

export default ListItemsManagerAdd
